module.exports = __webpack_public_path__ + "static/media/Sales_C2_logo.2acbca6c.svg";